// extracted by mini-css-extract-plugin
export default {"child1":"styles_child1__CGbO8","child2":"styles_child2__IzGoR","parent":"styles_parent__ggOuy"};